import React from 'react';
import LangSwitcher from '../../landing/LangSwitcher';
import { colors, borders, fonts } from './tokens';

interface TopBarProps {
    dateLabel: string;
    stageLabel?: string;
    pointsLabel?: string;
    onSignOut: () => void;
    onRecalculate?: () => void;
    recalcLabel?: string;
    dashboardLabel?: string;
    roadmapLabel?: string;
    logoutLabel?: string;
}

const TopBar: React.FC<TopBarProps> = ({
    dateLabel,
    stageLabel,
    pointsLabel,
    onSignOut,
    onRecalculate,
    recalcLabel,
    dashboardLabel = 'Dashboard',
    roadmapLabel = 'Roadmap',
    logoutLabel = 'Log out',
}) => (
    <div
        className="dash-edit__topbar"
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '8px 0 24px',
            borderBottom: borders.hairline,
        }}
    >
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            <img
                src={`${process.env.PUBLIC_URL || ''}/images/logo-mark.png`}
                alt="DoYourStep"
                style={{ height: 22, width: 'auto', display: 'block' }}
            />
            <div
                style={{
                    width: 1,
                    height: 14,
                    background: 'rgba(255,255,255,0.14)',
                    margin: '0 4px',
                }}
            />
            <div style={{ fontSize: 13, color: colors.muted }}>{dateLabel}</div>
        </div>

        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: 28,
                fontSize: 13,
                color: colors.muted,
            }}
        >
            <span style={{ color: colors.textPrimary }}>{dashboardLabel}</span>
            <button
                type="button"
                style={{
                    cursor: 'pointer',
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                    font: 'inherit',
                    color: 'inherit',
                    letterSpacing: 'inherit',
                }}
                onClick={() => {
                    const el = document.getElementById('tasks-roadmap');

                    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }}
            >
                {roadmapLabel}
            </button>

            {(stageLabel || pointsLabel) && (
                <>
                    <span style={{ color: 'rgba(255,255,255,0.18)' }}>·</span>
                    <span
                        style={{
                            color: colors.text,
                            fontFamily: fonts.mono,
                            fontSize: 12,
                            letterSpacing: '-0.01em',
                        }}
                    >
                        {stageLabel}
                        {stageLabel && pointsLabel ? ' · ' : ''}
                        {pointsLabel}
                    </span>
                </>
            )}

            {onRecalculate && (
                <>
                    <span style={{ color: 'rgba(255,255,255,0.18)' }}>·</span>
                    <button
                        type="button"
                        onClick={onRecalculate}
                        style={{
                            background: 'transparent',
                            color: colors.muted,
                            border: 'none',
                            padding: 0,
                            fontSize: 13,
                            fontFamily: 'inherit',
                            cursor: 'pointer',
                            letterSpacing: 'inherit',
                        }}
                    >
                        {recalcLabel ?? 'Recalculate'}
                    </button>
                </>
            )}

            <span style={{ color: 'rgba(255,255,255,0.18)' }}>·</span>
            <LangSwitcher />

            <span style={{ color: 'rgba(255,255,255,0.18)' }}>·</span>
            <button
                type="button"
                onClick={onSignOut}
                style={{
                    background: 'transparent',
                    color: colors.muted,
                    border: 'none',
                    padding: 0,
                    fontSize: 13,
                    fontFamily: 'inherit',
                    cursor: 'pointer',
                    letterSpacing: 'inherit',
                }}
            >
                {logoutLabel}
            </button>
        </div>
    </div>
);

export default TopBar;
